import React from 'react'
import blank_image1 from "../../../Assets/Images/sp5.png"
import blank_image2 from "../../../Assets/Images/sp6.png"
import blank_image3 from "../../../Assets/Images/sp7.png"
import blank_image4 from "../../../Assets/Images/sp8.png"
import './footer.css'

export default function Footer() {
    return (
        <>
            <div className="f-container">
                <p className='black-text-clip'>Enroll now and be part of our vibrant afterschool sports program! Bulk discounts are also available. For more information, contact us at (347) 212-0028.</p>
                <div className="f-image-container">
                    <div className="f-image-item"><img src={blank_image1} alt="blank Image" /></div>
                    <div className="f-image-item"><img src={blank_image2} alt="blank Image" /></div>
                    <div className="f-image-item"><img src={blank_image3} alt="blank Image" /></div>
                    <div className="f-image-item"><img src={blank_image4} alt="blank Image" /></div>
                </div>
            </div>
        </>
    )
}
